import React from 'react';

import * as styles from './Debug.styles';

interface Props {
  data: NonNullable<unknown> | null | undefined | never;
}

const Debug: React.FC<Props> = ({ data }) => (
  <styles.DebugContainer>
    <code>{JSON.stringify(data, null, 2)}</code>
  </styles.DebugContainer>
);

export default Debug;
